<template>
    <RadioToggleButtons
        v-model="inputedValue"
        :values="values"
        class="pochi-radio-toggle-button"
        :class="className"
        x-color="#02AD90"
        :x-textColor="textColor"
        x-selectedTextColor="#fff"
        v-bind="{ ...colors, textColor, }"
    />
</template>

<script>
const colors = [
    'normal',
    'accent',
    'primary',
    'seccondary',
];


export default {
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        values: {
            type: Array,
            required: true,
        },
        color: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return colors.indexOf(value ?? 'normal') !== -1;
            },
        },
        // TODO: ルールきめしたい
        textColor: {
            type: String,
            default: '#3B4043',
        },
        small: {
            type: Boolean,
            default: false,
        },
        xSmall: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
        xLarge: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        inputedValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            },
        },
        colors: function() {
            // TODO: colorに対して配色を指定できるようにする
            switch (this.color) {
                case 'normal':
                case 'accent':
                case 'primary':
                case 'seccondary':
                default:
                    return {
                        'color':             '#02AD90',
                        'textColor':         '#3B4043',
                        'selectedTextColor': '#FFF',
                    };
            }
        },
        className: function() {
            return {
                [`pochi-radio-toggle-button__color-${this.color}`]: true,
                'pochi-radio-toggle-button__size-small':    this.small,
                'pochi-radio-toggle-button__size-x-small':  this.xSmall,
                'pochi-radio-toggle-button__size-large':    this.large,
                'pochi-radio-toggle-button__size-x-large':  this.xLarge,
            };
        },
    },
}
</script>

<style lang="sass">
// TODO: size調整
.pochi-radio-toggle-button
    .radio-toggle-button
        padding: 10px
        &.is-selected
            // defaultのスタイルを上書き
            border-color: $mainColor !important
            background-color: $mainColor !important
    &__size-small .radio-toggle-button
        padding: 7px

@include sp()
    .pochi-radio-toggle-button
        .radio-toggle-button
            padding: 5px
</style>
